<template>
    <div class="content-card">
        <div class="content-card-title d-flex justify-content-start flex-wrap gap-2">
            <button v-for="(filter, index) in filters" :key="index"
                :class="['btn', 'btn-filter', filter.active ? 'btn-outline-primary btn-active text-white' : 'btn-outline-secondary']"
                @click="setActiveFilter(index)">
                <i class="fa-icon fa-solid" :class="[filter.active ? 'fa-circle-check ' : 'fa-circle']"></i>{{
                    filter.name }}
            </button>
        </div>
        <div class="content-card-body p-0">
            <app-tableThai  v-if="activeFilter == 1"
            v-bind:toDay="toDay(selectDate)"
                v-bind:dataList="getLottoResultAllList[0].filter(v => v.title != 'หวยรัฐบาล')"
                />
            <!-- <app-tableLao v-if="activeFilter == 2" /> -->
            <!-- <app-tableHanoy v-if="activeFilter==3" /> -->
            <app-tableSet v-if="activeFilter == 4 "
                v-bind:toDay="toDay(selectDate)" v-bind:isMobile="$isMobile(selectDate)"
                v-bind:dataList="getLottoResultAllList[2]" />
            <app-tableSetInter v-if="activeFilter == 5 "
                v-bind:toDay="toDay(selectDate)" v-bind:isMobile="$isMobile(selectDate)"
                v-bind:dataList="getLottoResultAllList[2]" />
            <app-tableYeekee v-if="activeFilter == 6"
            :toDay="toDay(selectDate)"
                :dataList="getLottoResultAllList[1][0]"
                :u8Type="0"
                :isVip="false"
                 />
            <app-tableYeekeeVIP v-if="activeFilter == 7 "
            :toDay="toDay(selectDate)"
                :dataList="getLottoResultAllList[1][1]"
                :u8Type="0"
                :isVip="false" />
            <app-tableYeekeeExpress v-if="activeFilter == 8 "
            :toDay="toDay(selectDate)"
                :dataList="getLottoResultAllList[1][2]"
                :u8Type="0"
                :isVip="false" />

        </div>
    </div>
</template>

<script>

import tableThai from '@/components/sakha/lotto/tableThai'
// import tableLao from '@/components/sakha/lotto/tableLao'
// import tableHanoy from '@/components/sakha/lotto/tableHanoy'
import tableSet from '@/components/sakha/lotto/tableSet'
import tableSetInter from '@/components/sakha/lotto/tableSetInter'
import tableYeekee from '@/components/sakha/lotto/tableYeekee'
import tableYeekeeVIP from '@/components/sakha/lotto/tableYeekeeVIP'
import tableYeekeeExpress from '@/components/sakha/lotto/tableYeekeeExpress'
import { mapActions, mapGetters } from 'vuex'
import { format } from 'date-fns'
export default {
  props: {
    DateSelected: {
      type: String,
      default: ''
    }
  },
  components: {
    'app-tableThai': tableThai,
    // 'app-tableLao': tableLao,
    // 'app-tableHanoy': tableHanoy,
    'app-tableSet': tableSet,
    'app-tableSetInter': tableSetInter,
    'app-tableYeekee': tableYeekee,
    'app-tableYeekeeVIP': tableYeekeeVIP,
    'app-tableYeekeeExpress': tableYeekeeExpress

  },
  data () {
    return {
      selectDate: '',
      filters: [
        { id: '1', name: 'หวยไทย', active: true },
        // { id: '2', name: 'หวยลาว', active: false },
        // { id: '3', name: 'หวยฮานอย', active: false },
        { id: '4', name: 'หวยหุ้นไทย', active: false },
        { id: '5', name: 'หวยหุ้นต่างประเทศ', active: false },
        { id: '6', name: 'หวยยีกี', active: false },
        { id: '7', name: 'หวยยีกี VIP', active: false },
        { id: '8', name: 'หวยยีกี Express', active: false }
      ],
      activeFilter: 1
    }
  },
  computed: {
    ...mapGetters(['getLottoResultAllList'])
  },
  methods: {
    ...mapActions(['setLoading', 'getLottoResultAll']),
    toDay: (data) => {
      if (data === '') {
        return format(new Date(), 'dd MMMM yyyy')
      } else {
        return format(new Date(data), 'dd MMMM yyyy')
      }
    },
    setActiveFilter (index) {
      this.filters.forEach((filter, i) => {
        filter.active = i === index
      })
      this.activeFilter = this.filters[index].id
    }
  },
  watch: {
    selectDate: function (val) {
      this.showOverlay = true
      this.getLottoResultAll(val)
    },
    getLottoResultAllList: function (val) {
      if (this.showOverlay === true) {
        this.showOverlay = false
      }
    }
  }
}
</script>

<style scoped>
.btn-active {
    background-color: #007bff;
    color: white;
}
</style>
